import { u2000TodayOrgYmd } from '../../u2000Core/tools/U2000DateTimeHelpers';

const YM_RE = /^(\d{4})-(\d{2})$/;

/** Valide un mois civil `yyyy-MM`. */
export function u340xIsValidYm(ym: string): boolean {
  const m = YM_RE.exec(ym.trim());
  if (!m) return false;
  const month = Number(m[2]);
  return month >= 1 && month <= 12;
}

/** Mois civil org courant (`yyyy-MM`). */
export function u340xTodayOrgYm(timeZone?: string): string {
  return u2000TodayOrgYmd(timeZone).slice(0, 7);
}

/**
 * Décale un mois `yyyy-MM` de `monthOffset` mois (arithmétique civile pure).
 * Retourne null si le format est invalide.
 */
export function u340xShiftYm(ym: string, monthOffset: number): string | null {
  const m = YM_RE.exec(ym.trim());
  if (!m) return null;
  const year = Number(m[1]);
  const month = Number(m[2]);
  if (month < 1 || month > 12) return null;
  const absolute = year * 12 + (month - 1) + monthOffset;
  const nextYear = Math.floor(absolute / 12);
  const nextMonth = (absolute % 12) + 1;
  return `${String(nextYear).padStart(4, '0')}-${String(nextMonth).padStart(2, '0')}`;
}
